/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  Autocomplete,
  Tooltip,
  Typography,
  Stack,
  Chip,
  IconButton,
  FormHelperText,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
import { Formik, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import HelpIcon from '@mui/icons-material/Help';
import SettingAction from '../../../store/actions/SettingAction';
import { ValidateSettingsMail } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { mail, index, store } from '../../../utils/constants';

export default function MailConfiguration() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { generalData } = useSelector((state) => state.setting);

  useEffect(() => {
    dispatch(SettingAction.getGeneralSettings());
  }, [dispatch]);

  useEffect(() => {
    if (generalData && generalData?.data) {
      setData(generalData.data);
    }
  }, [generalData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    // from_email: data?.from_email ?? '',
    cc_mail: data?.cc_mail ?? [],
    reply_to_mail: data?.reply_to_mail ?? ''
  };

  const permissionAccess = !(useHasPermission(mail, index) && useHasPermission(mail, store));

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography component="h2" variant="h2">
            Mail Configuration
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidateSettingsMail}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateGeneralSettings(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  {/* <Grid item lg={4} xl={4}>
                    <TextField
                      error={errors.from_email && touched.from_email}
                      label="From Email"
                      className=""
                      fullWidth
                      type="email"
                      name="from_email"
                      value={values.from_email}
                      disabled={permissionAccess}
                      placeholder="Enter From Email"
                      onChange={(e) => {
                        setFieldValue('from_email', e.target.value);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      helperText={errors.from_email && touched.from_email && errors.from_email}
                      margin="normal"
                      variant="outlined"
                      required={false}
                      InputLabelProps={{ required: !permissionAccess }}
                    />
                  </Grid> */}
                  <Grid item lg={4} xl={4} sx={{ position: 'relative' }}>
                    <Tooltip
                      title="The email field accepts multiple inputs. Please enter emails by typing and press Enter."
                      arrow
                      placement="bottom-end"
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '-11px',
                          right: 0
                        }}
                        size="small"
                        aria-label="info"
                      >
                        <HelpIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Field name="cc_mail">
                      {({ field }) => (
                        <Autocomplete
                          {...field}
                          options={[]}
                          multiple
                          freeSolo
                          disabled={permissionAccess}
                          limitTags={2}
                          onChange={(e, newvalue) => {
                            setFieldValue('cc_mail', newvalue);
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, idx) => {
                              const isInvalidEmail = errors.cc_mail && errors.cc_mail[idx];
                              return (
                                <div className="tagsValue" key={idx}>
                                  <Tooltip title={isInvalidEmail || option} arrow>
                                    <Chip
                                      size="small"
                                      color={isInvalidEmail ? 'error' : 'secondary'}
                                      variant="outlined"
                                      sx={{ width: '90px !important' }}
                                      label={option}
                                      {...getTagProps({ idx })}
                                      onDelete={() => {
                                        const filteredValues = values.cc_mail.filter(
                                          (_, i) => i !== idx
                                        );
                                        setFieldValue('cc_mail', filteredValues);
                                      }}
                                    />
                                  </Tooltip>
                                  {isInvalidEmail && (
                                    <FormHelperText error>{errors.cc_mail[idx]}</FormHelperText>
                                  )}
                                </div>
                              );
                            })
                          }
                          getOptionLabel={(option) => option}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={!!errors.cc_mail}
                              helperText={
                                typeof errors.cc_mail === 'string' ? errors.cc_mail : undefined
                              }
                              label="CC Email"
                              placeholder="Enter CC Email"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: !permissionAccess }}
                            />
                          )}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item lg={4} xl={4}>
                    <TextField
                      error={errors.reply_to_mail && touched.reply_to_mail}
                      label="Reply Email"
                      className=""
                      fullWidth
                      type="email"
                      name="reply_to_mail"
                      value={values.reply_to_mail}
                      disabled={permissionAccess}
                      placeholder="Enter Reply Email"
                      onChange={(e) => {
                        setFieldValue('reply_to_mail', e.target.value);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      helperText={
                        errors.reply_to_mail && touched.reply_to_mail && errors.reply_to_mail
                      }
                      margin="normal"
                      variant="outlined"
                      required={false}
                      InputLabelProps={{ required: !permissionAccess }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
